"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PackageEnum = void 0;
var PackageEnum;
(function (PackageEnum) {
  /**
   * Пакет условий услуги с фиксированной серией занятий
   *
   * @version 20221225
   */
  PackageEnum["ServiceContractTerms20221225Package"] = "ServiceContractTerms20221225Package";
  /**
   * Пакет условий услуги с фиксированной или повторяющейся серией занятий
   *
   * @version 20230418
   */
  PackageEnum["ServiceContractTerms20230418Package"] = "ServiceContractTerms20230418Package";
  /**
   * Пакет условий подписки на тарифный план
   *
   * @version 20240118
   */
  PackageEnum["AccountPlanTerms20240118Package"] = "AccountPlanTerms20240118Package";
})(PackageEnum = exports.PackageEnum || (exports.PackageEnum = {}));
